// import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {FmlxModal} from 'fmlx-common-ui';
import {FMLX_BUTTON, FMLX_MODAL} from '../../const/FmlxComponentEnum';
import {roleBusiness} from '../../stores/business/roleBusiness';
import RoleModalContent from './RoleModalContent';
import ManageDepartments from '../Management/ManageDepartments';
import ManageRoles from '../Management/ManageRoles';
import './ManageDepartmentRole.scss';
import {departmentBusiness} from '../../stores/business/departmentBusiness';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';

const ManageDepartmentRole = () => {
  const [state, setState] = useState({
    departments: [],
    selectedDepartment: null,
    roles: [],
    isModalOpen: false,
    isModalContentLoading: false,
  });
  const {userRoleId, userId} = useSelector((s) => ({
    userRoleId: s.appState.user?.authRole?.id,
    userId: s.appState.user?.id,
  }), shallowEqual);
  const dispatch = useDispatch();

  const fetchDepartments = async (userId) => {
    const departments = await dispatch(departmentBusiness.getAllDepartment(userId));
    if (departments) {
      setState((s) => ({
        ...s,
        departments: departments,
      }))
    }
  };

  const fethcRoles = async () => {
    const roles = await roleBusiness.getAllRole();
    if (roles) {
      setState((s) => ({
        ...s,
        roles: roles.map((role) => ({
          ...role,
          checked: false
        }))
      }))
    }
  };

  useEffect(() => {
    (async () => {
      await fetchDepartments(userId);
      await fethcRoles();
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const onSaveClickHandler = async () => {
    const checkedRoles = state.roles.filter((role) => role.checked);
    const payload = {
      ...state.selectedDepartment,
      roleIds: checkedRoles.map((cr) => cr.id),
    };
    await dispatch(departmentBusiness.updateDepartment(payload));
    setState((s) => ({...s, isModalOpen: false}));
  };

  const onOpenModalClickHandler = async (e, department) => {
    setState((s) => ({...s, isModalOpen: true, isModalContentLoading: true}));
    const roles = await roleBusiness.getRoleByDeptId(department.id);
    setState((s) => ({
      ...s,
      isModalContentLoading: false,
      selectedDepartment: department,
      roles: s.roles.map((role) => {
        if (roles) {
          const selectedRole = roles.find((r) => r.id === role.id);
          if (selectedRole) {
            return {...role, checked: true}
          }
        }
        return {...role, checked: false}
      })
    }));
  };

  const onRoleCheckedChangeHandler = (e, roleId) => {
    setState((s) => ({
      ...s,
      roles: s.roles.map((role) => {
        if (role.id === roleId) {
          return {
            ...role,
            checked: e.target.checked
          }
        }
        return role;
      })
    }))
  };

  return (
    <div className='manage-department-role'>
      <div className='manage-department-role--table-department'>
        <ManageDepartments
          userRoleId={userRoleId}
          departments={state.departments}
          onOpenModalClick={onOpenModalClickHandler}
          fetchDepartments={fetchDepartments}
        />
      </div>
      <div className='manage-department-role--table-role'>
        <ManageRoles
          userRoleId={userRoleId}
          roles={state.roles}
          fetchRoles={fethcRoles}
        />
      </div>
      <FmlxModal
        open={state.isModalOpen}
        title="Add Role"
        size={FMLX_MODAL.SIZE.MD}
        onCloseClick={() => {
          setState((s) => ({...s, isModalOpen: false}))
        }}
        primaryButton={{
          show: true,
          disabled: state.isModalContentLoading ? true : false,
          label: 'Save',
          type: FMLX_BUTTON.TYPE.PRIMARY,
          variant: FMLX_BUTTON.VARIANT.CONTAIN,
          onClick: onSaveClickHandler
        }}
        secondaryButton={{
          show: false,
        }}
        tertiaryButton={{
          show: false,
        }}
      >
        <RoleModalContent
          roles={state.roles}
          isLoading={state.isModalContentLoading}
          onRoleCheckedChange={onRoleCheckedChangeHandler}
        />
      </FmlxModal>
    </div>
  );
};

// ManageDepartmentRole.propTypes = {};

// ManageDepartmentRole.defaultProps = {};

export default ManageDepartmentRole;
